import { render, staticRenderFns } from "./Ninjas.vue?vue&type=template&id=707b9bcc&scoped=true&"
import script from "./Ninjas.vue?vue&type=script&lang=js&"
export * from "./Ninjas.vue?vue&type=script&lang=js&"
import style0 from "./Ninjas.vue?vue&type=style&index=0&id=707b9bcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b9bcc",
  null
  
)

component.options.__file = "Ninjas.vue"
export default component.exports